import { FC } from 'react'
import styled from 'styled-components'
import useSelectedCategories from '@app.feature/jobCategory/hooks/useSelectedCategories'
import ResetButton from '../../ResetButton'
import SubmitButton from './SubmitButton'

interface IFJobCategoryBottomSheetBottomProps {
  onSubmit: (categoryIds: string[]) => void
  className?: string
}

const JobCategoryBottomSheetBottom: FC<IFJobCategoryBottomSheetBottomProps> = ({
  onSubmit,
  className,
}) => {
  const { selectedCategories } = useSelectedCategories()

  return (
    <StyledWrapper className={className}>
      <ResetButton className="reset-button" />
      <SubmitButton
        onClick={() => {
          onSubmit(selectedCategories.map((category) => category.id))
        }}
        disabled={selectedCategories.length === 0}
      />
    </StyledWrapper>
  )
}

export default JobCategoryBottomSheetBottom

const StyledWrapper = styled.div`
  display: flex;
  padding: 15px 20px;

  .reset-button {
    padding: 13px 23px 13px 13px;
    white-space: nowrap;
    margin-right: 10px;
  }
`
